import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MemberHeader = _resolveComponent("MemberHeader")!
  const _component_MemberInfoSection = _resolveComponent("MemberInfoSection")!
  const _component_HappeningOverview = _resolveComponent("HappeningOverview")!
  const _component_RewardOverview = _resolveComponent("RewardOverview")!
  const _component_OfferOverview = _resolveComponent("OfferOverview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MemberHeader),
    _createVNode(_component_MemberInfoSection),
    _createVNode(_component_HappeningOverview),
    _createVNode(_component_RewardOverview),
    _createVNode(_component_OfferOverview, { "is-privilege": true }),
    ($setup.type !== 1)
      ? (_openBlock(), _createBlock(_component_OfferOverview, {
          key: 0,
          "is-privilege": false
        }))
      : _createCommentVNode("", true)
  ], 64))
}